"use stric"

import api from './apiService.js'
import WithToken from './tokenService'
import configuration from './../../config.json'

var CarsTypesService = {
  getCarsTypes: function () {
    return api.get('/unittypes', WithToken.headersToken(
      {},
      configuration.cookieName
    ))
  },
}

export default CarsTypesService